export default __webpack_public_path__ + "static/media/amex.4bac4ca1.svg";